if (typeof FeaturedRecipesTabs !== 'function') {

  class FeaturedRecipesTabs extends HTMLElement {
    constructor() {
      super();

      this.navItems = this.querySelectorAll("[data-js-featured-recipes-nav]");
      this.sections = this.querySelectorAll("[data-js-featured-recipes-section]");

      this.init();
    }

    init() {
      this.navItems.forEach((navItem) => {
        navItem.addEventListener("click", this.onNavItemClick.bind(this));
      });
    }

    onNavItemClick(evt) {
      const targetSectionKey = evt.currentTarget.dataset.jsFeaturedRecipesNav;
      this.showSection(targetSectionKey);
    }

    showSection(key) {
      const targetSection = Array.from(this.sections).find((section) => section.dataset.jsFeaturedRecipesSection === key);
      const targetNavItem = Array.from(this.navItems).find((navItem) => navItem.dataset.jsFeaturedRecipesNav === key);
      if (!targetSection || !targetNavItem) return;

      // Show section
      this.sections.forEach((section) => section.classList.add("hide"));
      targetSection.classList.remove("hide");

      // Highlight nav
      this.navItems.forEach((nav) => nav.classList.remove("active"));
      targetNavItem.classList.add("active");
    }

  }

  if ( typeof customElements.get('featured-recipes-tabs') == 'undefined' ) {
		customElements.define('featured-recipes-tabs', FeaturedRecipesTabs);
	}
}